import { useState } from "react";
import { Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import { Vocabulary } from "../../Utils/Vocabulary";
import styles from "../../Styles/vehicleInfoCell.module.css";

type Props = {
  name: string;
  vin?: string | null;
  vehicleId?: number | null;
  compact?: boolean;
};

export default function VehicleInfoCell({ name, vin, vehicleId, compact = false }: Props) {
  const [copied, setCopied] = useState(false);

  function handleCopy(e: React.MouseEvent) {
    e.stopPropagation();
    e.preventDefault();
    if (!vin) return;
    navigator.clipboard.writeText(vin).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }

  if (compact) {
    return (
      <div className={styles.compactRoot}>
        <div className={styles.compactNameRow}>
          <DirectionsCarIcon className={styles.compactCarIcon} />
          {vehicleId ? (
            <a
              href={`/vehiclesDashboard/vehicleDetails/${vehicleId}`}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.compactNameLink}
              onClick={(e) => e.stopPropagation()}
              onPointerDown={(e) => e.stopPropagation()}
            >
              {name}
            </a>
          ) : (
            <span className={styles.compactNamePlain}>{name}</span>
          )}
          {vehicleId && (
            <a
              href={`/vehiclesDashboard/vehicleDetails/${vehicleId}`}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.compactOpenIcon}
              onClick={(e) => e.stopPropagation()}
              onPointerDown={(e) => e.stopPropagation()}
              title={Vocabulary.openInNewTab}
            >
              <OpenInNewIcon style={{ fontSize: 11 }} />
            </a>
          )}
        </div>
        {vin && (
          <div className={styles.compactVinRow}>
            <span className={styles.compactVin}>{vin}</span>
            <Tooltip title={copied ? Vocabulary.copied : Vocabulary.copyVin} placement="top" arrow>
              <button
                className={`${styles.compactCopyBtn} ${copied ? styles.copyBtnDone : ""}`}
                onClick={handleCopy}
                onPointerDown={(e) => e.stopPropagation()}
              >
                {copied
                  ? <CheckIcon style={{ fontSize: 11 }} />
                  : <ContentCopyIcon style={{ fontSize: 11 }} />}
              </button>
            </Tooltip>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={styles.root}>
      <div className={styles.nameRow}>
        {vehicleId ? (
          <a
            href={`/vehiclesDashboard/vehicleDetails/${vehicleId}`}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.nameLink}
            onClick={(e) => e.stopPropagation()}
            onPointerDown={(e) => e.stopPropagation()}
          >
            {name}
          </a>
        ) : (
          <span className={styles.namePlain}>{name}</span>
        )}
        {vehicleId && (
          <a
            href={`/vehiclesDashboard/vehicleDetails/${vehicleId}`}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.openIcon}
            onClick={(e) => e.stopPropagation()}
            onPointerDown={(e) => e.stopPropagation()}
            title={Vocabulary.openInNewTab}
          >
            <OpenInNewIcon style={{ fontSize: 11 }} />
          </a>
        )}
      </div>
      {vin && (
        <div className={styles.vinRow}>
          <span className={styles.vinLabel}>{Vocabulary.vin}:</span>
          <span className={styles.vinValue}>{vin}</span>
          <Tooltip title={copied ? Vocabulary.copied : Vocabulary.copyVin} placement="top" arrow>
            <button
              className={`${styles.copyBtn} ${copied ? styles.copyBtnDone : ""}`}
              onClick={handleCopy}
              onPointerDown={(e) => e.stopPropagation()}
            >
              {copied
                ? <CheckIcon style={{ fontSize: 10 }} />
                : <ContentCopyIcon style={{ fontSize: 10 }} />}
            </button>
          </Tooltip>
        </div>
      )}
    </div>
  );
}
